export default "__VITE_ASSET__e34d5bbb__"